import { render, staticRenderFns } from "./ModalSAExplanation.vue?vue&type=template&id=a8cd1fc2"
import script from "./ModalSAExplanation.vue?vue&type=script&lang=js"
export * from "./ModalSAExplanation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports